import React, { Fragment, useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Drawer, Paper, colors } from '@material-ui/core'
import { Hidden } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import { Navigation } from 'components'
import navigationConfig from './navigationConfig'
import superAdminNavigationConfig from './superAdminNavigationConfig'
import adminNavigationConfig from './adminNavigationConfig'
import { useSelector } from 'react-redux'
import { NavigationListItem } from 'components/Navigation/components'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    overflowY: 'auto',
    backgroundColor: '#1F2125'
  },
  navBar: {
    zIndex: 3,
    width: 300,
    flex: '0 0 auto',
    transition: 'all 0.3s ease-in-out'
  },
  content: {
    padding: theme.spacing(2)
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  },
  divider: {
    backgroundColor: colors.grey[700]
  },
  navigation: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 'calc(100vh - 96px)'
  },
  lowerNavContainer: {
    backgroundColor: '#2B2D33',
    margin: '-1rem',
    padding: '1rem'
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium
  }
}))

const NavBar = props => {
  const { openMobile, onMobileClose, ...rest } = props
  const classes = useStyles()
  const router = useRouter()
  const userType = useSelector(state => state.session.userType)
  const isCollapsedMenu = useSelector(state => state.session?.isCollapsedMenu)
  const navBarItems = userType?.toLowerCase()?.includes('super')
    ? superAdminNavigationConfig
    : userType === 'admin'
    ? adminNavigationConfig
    : navigationConfig
  const lowerNavContent = [
    {
      title: 'Visit Help Center',
      href: '/helpcenter',
      icon: HelpOutlineIcon
    },
    {
      title: 'Report an issue',
      href: '/report',
      icon: ErrorOutlineIcon
    }
  ]
  useEffect(() => {
    if (openMobile) {
      onMobileClose && onMobileClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.location.pathname])

  const navbarContent = (
    <div className={classes.content}>
      <nav className={classes.navigation}>
        <div>
          {navBarItems?.map(list => (
            <Navigation
              component="div"
              key={list.title + 1}
              pages={list.pages}
              title={list.title}
            />
          ))}
        </div>
        <div className={classes.lowerNavContainer}>
          {lowerNavContent.map(item => (
            <NavigationListItem
              key={item.title}
              href={item.href}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </div>
      </nav>
    </div>
  )

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary">
          <div {...rest} className={clsx(classes.root, classes.navBar)}>
            {navbarContent}
          </div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Paper
          {...rest}
          className={clsx(classes.root, classes.navBar)}
          style={{
            width: isCollapsedMenu ? 95 : 300
          }}
          elevation={1}
          square>
          {navbarContent}
        </Paper>
      </Hidden>
    </Fragment>
  )
}

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
}

export default NavBar
